import { ProjectDto } from '@/core';
import { EpicGroupTypesEnum } from '../../Projects.Constructor.EpicGroups/hooks';

export const calculateAffectedByEpicItems = (projectData: ProjectDto, epicId: string) => {
  const affectedProducts = projectData.epicGroups.filter(
    (epicGroup) => epicGroup.type === EpicGroupTypesEnum.Products && epicGroup.epics.includes(epicId),
  );
  const affectedCostTypes = projectData.epicGroups.filter(
    (epicGroup) => epicGroup.type === EpicGroupTypesEnum.CostTypes && epicGroup.epics.includes(epicId),
  );
  const affectedSheets = projectData.sheets.filter((sheet) => sheet.epics.includes(epicId));

  return { affectedProducts, affectedCostTypes, affectedSheets };
};
